import React from 'react';
import { Outlet } from 'react-router-dom';
import AdminHeader from './AdminHeader';

// The outlet is a flex column with a definite height, so a page that wants to fill
// the viewport exactly (and scroll inside its own tables) can use flex: 1 / minHeight: 0.
// Pages that are simply taller than the viewport still overflow and scroll the body.
const layoutStyles: React.CSSProperties = {
	width: '100%',
	maxWidth: '100vw',
	flexGrow: 1,
	minHeight: 0,
	display: 'flex',
	flexDirection: 'column',
};

const mainStyles: React.CSSProperties = {
	height: '100vh',
	display: 'flex',
	flexDirection: 'column',
};

export default function AdminLayout() {
	return (
		<main style={mainStyles}>
			<div style={{ flexGrow: 0 }}>
				<AdminHeader />
			</div>
			<div style={layoutStyles}>
				<Outlet />
			</div>
		</main>
	);
}
